<template>
    <form-accordion
        name="broker-financials"
        section="Broker Financials"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <intro-index
            :property="property"
            :read_only="read_only"
        />

        <list-side-index
            v-if="our_sale"
            :commission_detail="property.deal.commission_detail"
            :read_only="read_only"
        />

        <purchase-side-index
            v-if="our_purchase"
            :commission_detail="property.deal.commission_detail"
            :read_only="read_only"
        />

        <closing-index
            :closing="property.closing"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import IntroIndex from './intro-index.vue';
import ListSideIndex from './list-side-index.vue';
import PurchaseSideIndex from './purchase-side-index.vue';
import ClosingIndex from './closing-index.vue';

export default {
    components: {
        IntroIndex,
        ListSideIndex,
        PurchaseSideIndex,
        ClosingIndex,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    computed: {
        our_sale() {
            return store.state.our_sale;
        },
        our_purchase() {
            return store.state.our_purchase;
        },
    },
}
</script>
